import { render } from "./CXFirstAidSettings.vue?vue&type=template&id=66e93170&scoped=true"
import script from "./CXFirstAidSettings.vue?vue&type=script&lang=js"
export * from "./CXFirstAidSettings.vue?vue&type=script&lang=js"

import "./CXFirstAidSettings.vue?vue&type=style&index=0&id=66e93170&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e93170"]])

export default __exports__